import React, { HTMLAttributes } from 'react';
import { createUseStyles } from '../theming';
import clsx from 'clsx';

const useStyles = createUseStyles({
  root: {
    color: '#000000de',
    fontSize: 18,
    fontWeight: 500,
    marginBottom: 24,
    borderBottom: '1px solid #e8e8e8',
    marginLeft: -24,
    marginRight: -24,
    marginTop: -8,
    paddingLeft: 24,
    paddingRight: 24,
    paddingBottom: 15,
  },
});

interface Props extends HTMLAttributes<HTMLDivElement> {
  title: string;
}

const CardTitle: React.FC<Props> = ({ className, style, title }) => {
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, className)} style={style}>
      {title}
    </div>
  );
};

export default CardTitle;
